module.exports = __webpack_public_path__ + "static/media/alcohol.027fb986.svg";